module.exports = __webpack_public_path__ + "static/media/clip.ce985afc.png";